
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea202"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea202"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// src/js/login.js

var $ccbGL = parcelRequire("ccbGL");

var $1MkCa = parcelRequire("1MkCa");
const $27435ee7e70aa165$var$loginForm = document.getElementById("loginForm");
const $27435ee7e70aa165$var$passwordInput = document.getElementById("password");
const $27435ee7e70aa165$var$loginBtn = document.getElementById("loginBtn");
const $27435ee7e70aa165$var$btnText = $27435ee7e70aa165$var$loginBtn?.querySelector(".btn-text");
const $27435ee7e70aa165$var$btnSpinner = $27435ee7e70aa165$var$loginBtn?.querySelector(".btn-spinner");
const $27435ee7e70aa165$var$loginError = document.getElementById("loginError");
// Check if already logged in
const $27435ee7e70aa165$var$savedFridge = (0, $1MkCa.getCurrentFridgeCode)();
if ($27435ee7e70aa165$var$savedFridge) // Already logged in, redirect to inventory
window.location.href = "inventory.html";
// Initialize Firebase
(0, $ccbGL.initializeFirebase)().then(()=>{
    console.log("Firebase ready for login");
}).catch((err)=>{
    console.error("Firebase init error:", err);
});
$27435ee7e70aa165$var$loginForm?.addEventListener("submit", async (e)=>{
    e.preventDefault();
    const password = $27435ee7e70aa165$var$passwordInput?.value?.trim();
    if (!password) return;
    // Show loading state
    $27435ee7e70aa165$var$setLoading(true);
    $27435ee7e70aa165$var$hideError();
    try {
        const fridge = await (0, $1MkCa.findFridgeByPassword)(password);
        if (fridge && fridge.code) {
            // Save fridge code and redirect
            (0, $1MkCa.setCurrentFridgeCode)(fridge.code);
            window.location.href = "inventory.html";
        } else $27435ee7e70aa165$var$showError("Feil passord. Pr\xf8v igjen.");
    } catch (err) {
        console.error("Login error:", err);
        $27435ee7e70aa165$var$showError("Noe gikk galt. Pr\xf8v igjen.");
    } finally{
        $27435ee7e70aa165$var$setLoading(false);
    }
});
function $27435ee7e70aa165$var$setLoading(loading) {
    if ($27435ee7e70aa165$var$loginBtn) $27435ee7e70aa165$var$loginBtn.disabled = loading;
    if ($27435ee7e70aa165$var$btnText) $27435ee7e70aa165$var$btnText.hidden = loading;
    if ($27435ee7e70aa165$var$btnSpinner) $27435ee7e70aa165$var$btnSpinner.hidden = !loading;
}
function $27435ee7e70aa165$var$showError(message) {
    if ($27435ee7e70aa165$var$loginError) {
        $27435ee7e70aa165$var$loginError.textContent = message;
        $27435ee7e70aa165$var$loginError.hidden = false;
    }
}
function $27435ee7e70aa165$var$hideError() {
    if ($27435ee7e70aa165$var$loginError) $27435ee7e70aa165$var$loginError.hidden = true;
}


//# sourceMappingURL=index.2201a4c7.js.map
